import PermissionTemplatesView from "./PermissionsTemplateView";
import {DEFAULT_PERMISSIONS_TEMPLATE_ID} from '../../../constants'
import messageResource from '../../../messageResource'

export default class EditPermissionsTemplateView extends PermissionTemplatesView {
    constructor($containerEl, params) {
        super($containerEl, params);

        this.state = {
            ...this.state,
            id: null,
        }
        this.onResetButtonClick = params.onResetButtonClick

        this.onStatePropertyChanged('id', () => {
            this._updateInput()
        })
    }

    afterRender() {
        super.afterRender();
        this.$el.addClass("editTemplateView");
        this.$resetButton.click(this.onResetButtonClick);

        this._updateInput()
    }

    _updateInput() {
        const isDefaultTemplate = this.state.id === DEFAULT_PERMISSIONS_TEMPLATE_ID
        this.find('.permissionsTemplateName').toggleClass('disabled', isDefaultTemplate)
        this.$nameInput.attr('disabled', isDefaultTemplate)
        if (isDefaultTemplate) {
            this._updateDefaultTemplateName()
        }
    }

    _updateDefaultTemplateName() {
        this.$nameInput.pVal(
            `${this.state.name} ${messageResource.getMessage('userlist.userdata.permissions_templates.js.menu.row.default_template')}`
        )
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/permissionsTemplates/EditPermissionsTemplateView.js